// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CourseOverview_cardContainer__oshAC","labIcon":"CourseOverview_labIcon__2VoN8"};